import { createSlice } from '@reduxjs/toolkit';

import { ClientPaymentMethodInfo } from 'types/client';

import { getClientPaymentMethodsInfo } from './clientThunks';

interface ClientState {
  paymentMethods: {
    default: ClientPaymentMethodInfo | null;
    all: ClientPaymentMethodInfo[];
    isLoading: boolean;
  };
}

const initialState: ClientState = {
  paymentMethods: {
    default: null,
    all: [],
    isLoading: false
  }
};

const clientSlice = createSlice({
  name: 'client',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getClientPaymentMethodsInfo.pending, (state) => {
        state.paymentMethods.isLoading = true;
      })
      .addCase(getClientPaymentMethodsInfo.fulfilled, (state, { payload }) => {
        const paymentMethods = payload || [];

        state.paymentMethods.all = paymentMethods;
        state.paymentMethods.default =
          paymentMethods.find((el) => el.isDefault === true) || null;
        state.paymentMethods.isLoading = false;
      })
      .addCase(getClientPaymentMethodsInfo.rejected, (state) => {
        state.paymentMethods.all = [];
        state.paymentMethods.default = null;
        state.paymentMethods.isLoading = false;
      });
  }
});

export default clientSlice.reducer;
